export default __webpack_public_path__ + "static/media/caixa-gov-vertical.4d88401e.png";